'use client';
//TODO: Complete
import { iFilterableArea } from '@/app/models/apiModels/filterableArea';
import { set } from 'lodash';
import { eAreaType } from '@/app/models/enum/areaType';

interface Props {
    filterableArea: iFilterableArea;
    orderStep1Url: string;
    translations: any;
}

export default function Area({ filterableArea, orderStep1Url, translations }: Props) {

    const getSizeMarkup = (size: iFilterableSize) => {
        let colSpans = 6;

        if (size.discount || size.ordPrice > 0) {
            colSpans = colSpans - 1;
        }

        if (!size.hasAvailableUnits) {
            colSpans = colSpans - 3;
        }

        const colSpanClass = `col-span-${colSpans}`;
        return (
            <>
                <div className="grid grid-cols-6 gap-2">
                    <span className={colSpanClass}>
                        {size.sizeInM2} m<span className="align-super text-[10.5px]">2</span>
                    </span>
                    {colSpans < 6 && (
                        <div className={`badges col-span-${6 - colSpans}`} >
                            {(size.discount || size.ordPrice > 0) && (
                                <span className="sale-badge">
                                    Salg
                                </span>
                            )}
                            {!size.hasAvailableUnits && (
                                <span className="no-vacancy-badge">
                                    NO VACANCY
                                </span>
                            )}
                        </div>
                    )}
                </div>
                <div>
                    {size.discount ? (
                        <>
                            <span>
                                {translations.pages.campaignListingPage.firstMonthDiscountPrice}
                            </span>
                            <span className="line-through font-color-grey">{size.price} {`${translations.general.priceUnit}/${translations.general.shortMonth}`}</span>
                        </>
                    ) : (
                        <>{size.price > 0 && (
                            <>
                                <span>{size.price} {`${translations.general.priceUnit}/${translations.general.shortMonth}`}</span>
                                {size.ordPrice > 0 && (
                                    <span className="text-sm text-gray-500 line-through font-color-grey">{size.ordPrice} {`${translations.general.priceUnit}/${translations.general.shortMonth}`}</span>
                                )}
                            </>
                        )}
                        </>
                    )}
                </div>
            </>
        )
    }

    return (

        <div>
            {filterableArea.type === eAreaType.Region && (
                <h2>{filterableArea.name}</h2>
            )}
            {filterableArea.type === eAreaType.City && (
                <h3>{filterableArea.name}</h3>
            )}
            {filterableArea.type === eAreaType.District && (
                <h4>{filterableArea.name}</h4>
            )}
            {filterableArea.facilities && filterableArea.facilities.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {filterableArea.facilities.map((facility, facilityIndex) => (
                        <div key={facilityIndex} className="mb-4">
                            <h4>{facility.name}</h4>
                            <p>
                                {facility.streetAddress}, {facility.zipCode ? `${facility.zipCode} ` : ""}{facility.city}
                            </p>
                            {facility.sizes && facility.sizes.length > 0 && (
                                <div className="grid grid-cols-1 gap-4">
                                    {facility.sizes.map((size, sizeIndex) => (
                                        <>
                                            {size.hasAvailableUnits ? (
                                                <a href={`${orderStep1Url}?siteId=${facility.facilityId}&groupName=${size.groupName}&sizeId=${size.id}`} key={sizeIndex} className="grid grid-cols-2 gap-4">
                                                    {getSizeMarkup(size)}
                                                </a>
                                            ) : (
                                                <div key={sizeIndex} className="grid grid-cols-2 gap-4 font-color-grey">
                                                    {getSizeMarkup(size)}
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
            {filterableArea.subAreas && filterableArea.subAreas.length > 0 && (
                <div>
                    {filterableArea.subAreas.map((subArea, subAreaIndex) => (
                        <Area
                            key={subAreaIndex}
                            filterableArea={subArea}
                            orderStep1Url={orderStep1Url}
                            translations={translations}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}


